import DOMPurify from 'dompurify';

// Sanitize DB/admin-provided HTML before dangerouslySetInnerHTML (XSS guard).
export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html || '', { USE_PROFILES: { html: true }, ADD_ATTR: ['target', 'rel'] });
